import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { SavedBy } from "@/admin/Recorded";
import { Table } from "@/admin/AdminLayout";

const RS = [["requested", "Requested"], ["approved", "Approved"], ["declined", "Declined"], ["received", "Item received"], ["refunded", "Refunded"], ["exchanged", "Exchanged"]];
const SS = [["requested", "Requested"], ["sent", "Posted"], ["cancelled", "Cancelled"]];
const Sel = ({ value, opts, onChange, testId }: any) => (
  <select value={value} onChange={(e) => onChange(e.target.value)} className="border border-neutral-300 text-xs px-2 py-1" data-testid={testId}>{opts.map(([k, l]: any) => <option key={k} value={k}>{l}</option>)}</select>
);

function LabelInfo({ r, onRetry }: any) {
  if (!r.label_status) return null;
  const msg: any = { creating: "Creating label…", sent: `Label emailed${r.label_tracking ? ` · ${r.label_tracking}` : ""}`, not_configured: "Label not sent — Australia Post not connected", failed: `Label failed: ${r.label_error || ""}` };
  return (
    <div className={`mt-1.5 text-[10px] max-w-[220px] ${r.label_status === "sent" ? "text-green-700" : r.label_status === "creating" ? "text-neutral-500" : "text-amber-700"}`} data-testid={`return-label-${r.id}`}>
      {msg[r.label_status]}
      {["failed", "not_configured"].includes(r.label_status) && <button onClick={onRetry} className="underline ml-1" data-testid={`return-label-retry-${r.id}`}>Retry</button>}
    </div>
  );
}

export function ServiceInbox() {
  const [d, setD] = useState<any>(null);
  const [tab, setTab] = useState("returns");
  const load = () => api.get("/admin-x/service").then((r) => setD(r.data));
  useEffect(() => { load(); }, []);
  const act = async (url: string, status: string) => { try { await api.put(url, { status }); load(); toast("Updated"); } catch (e) { toast.error(errMsg(e)); } };
  if (!d) return null;
  return (
    <div data-testid="service-inbox">
      <div className="flex gap-5 mb-4 text-xs">
        {[["returns", `Returns (${d.returns.filter((r: any) => r.status === "requested").length} new)`], ["sizers", `Ring sizers (${d.ring_sizers.filter((r: any) => r.status === "requested").length} to post)`]].map(([k, l]) => (
          <button key={k} onClick={() => setTab(k)} className={`pb-1 border-b ${tab === k ? "border-neutral-900" : "border-transparent text-neutral-500"}`} data-testid={`service-tab-${k}`}>{l}</button>
        ))}
      </div>
      {tab === "returns" ? (
        <Table head={["Requested", "Order", "Customer", "Items", "Type / reason", "Details", "Status"]} testId="returns-table">
          {d.returns.map((r: any) => (
            <tr key={r.id}>
              <td className="px-4 py-3 text-xs">{new Date(r.created_at).toLocaleString("en-AU")}</td>
              <td className="px-4 py-3 text-xs font-medium">{r.order_number}</td>
              <td className="px-4 py-3 text-xs"><a href={`mailto:${r.email}`} className="underline">{r.email}</a></td>
              <td className="px-4 py-3 text-xs">{r.items.join(", ")}</td>
              <td className="px-4 py-3 text-xs capitalize">{r.kind}<div className="normal-case text-neutral-500">{r.reason}</div></td>
              <td className="px-4 py-3 text-xs max-w-xs">{r.details}</td>
              <td className="px-4 py-3"><Sel value={r.status} opts={RS} onChange={(v: string) => act(`/admin-x/returns/${r.id}`, v)} testId={`return-status-${r.id}`} />
                <LabelInfo r={r} onRetry={async () => { try { await api.post(`/admin-x/returns/${r.id}/label`); toast("Creating label…"); setTimeout(load, 4000); } catch (e) { toast.error(errMsg(e)); } }} /><SavedBy d={r} testId={`return-saved-${r.id}`} /></td>
            </tr>
          ))}
        </Table>
      ) : (
        <Table head={["Requested", "Name", "Email", "Postal address", "Status"]} testId="sizers-table">
          {d.ring_sizers.map((s: any) => (
            <tr key={s.id}>
              <td className="px-4 py-3 text-xs">{new Date(s.created_at).toLocaleString("en-AU")}</td>
              <td className="px-4 py-3 text-xs">{s.name}</td>
              <td className="px-4 py-3 text-xs"><a href={`mailto:${s.email}`} className="underline">{s.email}</a></td>
              <td className="px-4 py-3 text-xs">{[s.address1, s.address2, s.suburb, s.state, s.postcode, s.country].filter(Boolean).join(", ")}</td>
              <td className="px-4 py-3"><Sel value={s.status} opts={SS} onChange={(v: string) => act(`/admin-x/ring-sizers/${s.id}`, v)} testId={`sizer-status-${s.id}`} /><SavedBy d={s} testId={`sizer-saved-${s.id}`} /></td>
            </tr>
          ))}
        </Table>
      )}
    </div>
  );
}
